import React from 'react';
import { getText } from 'src/utils/i18n';
import LeadtimeWithBalloon from '../product-packaging-and-quick-detail/product-packaging/leadtime-with-balloon';
import '../product-packaging-and-quick-detail/index.scss';
import './index.scss';

const ProductLeadTimeTable = ({
  ladderPeriodList = [],
  i18n,
  quantityUnitStr = '',
  productIsMarketGoods = false,
}) => {
  if (productIsMarketGoods) return null;

  if (ladderPeriodList.length === 0) return null;

  const maxQuantity = ladderPeriodList.length - 1;
  const titleText = getText(
    i18n,
    'detailModule.detailMarketPackage.LeadTime',
    'Lead Time',
  );

  return (
    <dl className="leadtime-table">
      <dt className="leadtime-table__key" title={titleText}>
        {titleText}
        <LeadtimeWithBalloon i18n={i18n} />:
      </dt>
      <dd
        className="leadtime-table__value"
        title="Lead Time"
        style={{
          whiteSpace: 'normal',
        }}
      >
        <table className="supply-ability-table ui2-table ui2-table-normal ui2-table-zebra ui2-table-hover">
          <tbody>
            <tr>
              <td>
                {getText(
                  i18n,
                  'detailModule.supplyAbility.quantity',
                  'Quantity',
                )}
                ({quantityUnitStr})
              </td>
              {ladderPeriodList.map((item, index) => (
                <td key={index}>
                  {item.minQuantity} - {item.maxQuantity}
                </td>
              ))}
              <td>&gt;{ladderPeriodList[maxQuantity].maxQuantity}</td>
            </tr>
            <tr>
              <td>
                {getText(
                  i18n,
                  'detailModule.detailMarketPackage.EstTimeday',
                  'Est. Time(days)',
                )}
              </td>
              {ladderPeriodList.map((item, index) => (
                <td key={index}>{item.processPeriod}</td>
              ))}
              <td>
                {getText(
                  i18n,
                  'detailModule.detailMarketPackage.ToBeNegotiated',
                  'To be negotiated',
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </dd>
    </dl>
  );
};

export default ProductLeadTimeTable;
